<template>
  <div class="banner">
    <div class="iconContainer">
      <img src="../assets/img/logo.png" class="icon" />
    </div>
    <div class="textContainer">
      <div class="introContainer">
        <div>
          <img src="../assets/img/new/img_4.png" class="text" />
        </div>
        <div class="middleContainer">
          <img src="../assets/img/new/img_1.png" />
          <img src="../assets/img/new/img_2.png" />
          <img src="../assets/img/new/img_3.png" />
        </div>
        <div>
          <img src="../assets/img/new/txt_11.png" class="comment" />
        </div>
      </div>
      <div class="downloadContainer">
        <img
          src="../assets/img/new/img_btn.png"
          class="download"
          @click="$emit('go', 'top')"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "banner",
};
</script>

<style lang="less" scoped>
.banner {
  background: url("../assets/img/new/bg.png");
  background-size: 100% 100%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  .iconContainer {
    display: flex;
    align-items: center;
    margin-left: 0.8rem;;
    margin-right: 0.5rem;
    .icon {
      height: 7vmax;
      position: relative;
    }
  }

  .textContainer {
    display: flex;
    flex: 1 auto;
    align-items: center;

    .introContainer {
      display: flex;
      flex-direction: column;

      .text {
        height: 1.8vmax;
        margin-top: 2%;
      }
      .middleContainer {
        display: flex;
        align-items: start;
        flex-wrap: nowrap;
        transform: scale(0.8);
        transform-origin: top left;

        img {
          height: 2vmax;
        }
      }
      .comment {
        height: 2vmax;
        margin-left: 1%;
      }
    }

    .downloadContainer {
      display: flex;
      flex-grow: 1;
      align-items: center;
      justify-content: flex-end;
      margin-right: 0.5rem;

      .download {
        height: 4.5vmax;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/head-intro.vue